module.exports = __webpack_public_path__ + "media/assets/icons/plus-51d95337e4f70a90ead024b19d84e50d.png";